/** Format an ISO datetime for a buyer-facing "send on …" label. */
export function formatScheduledSendAt(
  iso: string | null | undefined,
): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/**
 * Buyer-facing description for a gift card tile. A restricted card leads with
 * what it's good for — that's the whole point of buying it — and keeps the
 * clinic's own description underneath.
 */
export function giftCardShopDescription(item: {
  description: string | null;
  giftCardRestrictionLabel?: string | null;
}): string | null {
  if (!item.giftCardRestrictionLabel) return item.description;
  const redeemableFor = `Redeemable for ${item.giftCardRestrictionLabel}.`;
  return item.description
    ? `${redeemableFor} ${item.description}`
    : redeemableFor;
}
